import { RouterProvider } from '@tanstack/react-router'
import { Router } from '@/main'
import { useAuth } from '../hooks/useAuth'

function TanStackRouterProvider({ router }: { router: Router }) {
  const auth = useAuth()

  return <RouterProvider router={router} context={{ auth }} />
}

export default TanStackRouterProvider
